import { createApp } from 'vue';
import { createPinia } from 'pinia'
import { useKioskStore } from '@/stores/useKioskStore';
import { useThemeStore } from '@/stores/useThemeStore';
import { useTranslationsStore } from '@/stores/useTranslationsStore';
import { useCatalogStore } from '@/stores/useCatalogStore';
import App from './App.vue';
import router from './router';
import i18n from './i18n'
import './assets/styles/main.scss';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(i18n);

router.isReady().then(async () => {
    const kioskStore = useKioskStore();
    const route = router.currentRoute.value;
    const kioskId = route.params.kioskId;
    const { fetchKiosk, getKioskStatus } = kioskStore;

    await fetchKiosk(kioskId);

    const { initTheme } = useThemeStore();
    const { fetchTranslations } = useTranslationsStore();
    const { fetchCatalog } = useCatalogStore();

    await Promise.all([
        initTheme(),
        fetchTranslations(),
        fetchCatalog(),
        getKioskStatus(),
    ]);

    insertGoogleFontsPreconnect();
    app.mount('#app');

    // const urlParams = new URLSearchParams(window.location.search);
    // const isLive = urlParams.get('live') === '1';

    // if (isLive) {
    //     app.mount('#app');
    // } else {
    //     document.body.innerHTML = '<h1>APP IS UNAVAILABLE BECAUSE OF MISSING "live=1" GET PARAM</h1>';
    //     document.body.style.cssText = 'display:flex;justify-content:center;align-items:center;height:100vh;font-family:sans-serif;';
    // }
});

function insertGoogleFontsPreconnect() {
    if (document.getElementById('gf-preconnect-googleapis')) return;

    const googleapis = document.createElement('link');
    googleapis.rel = 'preconnect';
    googleapis.href = 'https://fonts.googleapis.com';
    googleapis.id = 'gf-preconnect-googleapis';

    const gstatic = document.createElement('link');
    gstatic.rel = 'preconnect';
    gstatic.href = 'https://fonts.gstatic.com';
    gstatic.crossOrigin = '';
    gstatic.id = 'gf-preconnect-gstatic';

    document.head.appendChild(googleapis);
    document.head.appendChild(gstatic);
}
